import pageContext from 'salvo-lite/context'

import Newsletter from './components/Newsletter'
import Slider from './components/Slider'
import AjaxSearchSlider from './components/AjaxSearchSliders'
import Preload from './components/Preload'
import ProductForm from './components/ProductForm'
import Currencies from './components/Currencies'
import AddToCart from './components/AddToCart'
import CollectionFilter from './components/CollectionFilter'
import TextCounter from './components/TextCounter'
import ToggleClasses from './components/ToggleClasses'
import ProductZoom from './components/ProductZoom'

const components = {
    'form-newsletter': Newsletter,
    'currency-converter': Currencies,
    'collection-atc': AddToCart,
    'collection-filters': CollectionFilter,
    'slider': Slider,
    'ajax-search': AjaxSearchSlider,
    'preload': Preload,
    'product-form': ProductForm,
    'text-counter': TextCounter,
    'toggle-classes': ToggleClasses,
    'product-zoom': ProductZoom
}

const pages = {
}

class Theme {
    constructor () {
        this._components = []
        this._componentsById = {}
    }

    registerComponents () {
        for (let key in components) {
            var ComponentConstructor = components[key]
            var elements = document.querySelectorAll(`.js-component__${key}, [data-${key}]`)
            for (let elem of elements) {
                var instance = new ComponentConstructor(this, elem)
                this._components.push(instance)
                var id = elem.dataset.componentId
                if (id) {
                    this._componentsById[id] = instance
                }
                instance.onInit()
            }
        }
        window.ThemeComponents = this._components
        window.ThemeComponentsId = this._componentsById
        window.__Theme = this
    }

    registerPages () {
        var context = pageContext.getTemplate()
        for (let page in pages) {
            if (page === context) {
                var instance = new pages[page](this)
                instance.onInit()
            }
        }
    }

    getComponents () {
        return this._components
    }

    getComponentsById (id) {
        return this._componentsById[id]
    }

    getComponentsByType (componentConst, includeSubclasses = true) {
        var r = []
        for (let c of this._components) {
            if (includeSubclasses && c instanceof componentConst) {
                r.push(c)
            } else if (c.constructor === componentConst) {
                r.push(c)
            }
        }
        return r
    }

    getComponentByName (name) {
        var r = null
        for (let c of this._components) {
            if (c._name === name) {
                r = c
            }
        }
        return r
    }
}

export default Theme



// WEBPACK FOOTER //
// ./src/resources/scripts/Theme.js